module.exports = __webpack_public_path__ + "static/video-cursor-clos-eaec220d7f6340bd7ae5d7896889c01f.png";